export const eventRepeatPatterns = Object.freeze({
  WEEKLY: 'weekly',
  DAILY: 'daily',
  MONTHLY: 'monthly',
});
